import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";

const FreeConsultation = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        honeypot: '',
        timestamp: Date.now()
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Honeypot check
        if (formData.honeypot) {
            toast.error('Please send message later.');
            return;
        }

        // Bot speed submission check
        const submissionTime = Date.now();
        const timeDiff = submissionTime - formData.timestamp;
        if (timeDiff < 3000) {
            toast.error('Please send message later.');
            return;
        }

        // Cooldown based on previous submission from localStorage
        const lastSubmission = localStorage.getItem('freeConsultationLastSubmit');
        const cooldown = 30 * 60 * 1000; // 30 minutes

        if (lastSubmission && (Date.now() - parseInt(lastSubmission, 10)) < cooldown) {
            toast.warn('You have already submitted. Please try again later.');
            return;
        }

        try {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_FREE_CONSULTATION_MESSAGE_STORE;
            const response = await axios.post(`${apiBaseUrl}${Url}`, formData);

            if (response.status === 200) {
                toast.success('Message sent successfully!');
                setFormData({ name: '', phone: '', honeypot: '', timestamp: Date.now() });
                localStorage.setItem('freeConsultationLastSubmit', Date.now().toString());
            } else {
                toast.error('Something went wrong. Try again.');
            }
        } catch (error) {
            toast.error('Failed to send message.');
        }
    };

    return (
        <div className="apply-area">
            <div className="container">
                <div className="col-lg-11 col-xl-12">
                    <div className="apply-form" style={{ backgroundColor: '#E95A30' }}>
                        <form onSubmit={handleSubmit}>
                            <div className="apply-header">
                                <h4 className="title text-white">ফ্রি পরামর্শ পেতে - </h4>
                                <button type="submit" className="btn btn-light">
                                    সাবমিট করুন <i className="fas fa-arrow-circle-right"></i>
                                </button>
                            </div>
                            <div className="row g-3">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <div className="form-icon">
                                            <i className="far fa-user-tie"></i>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                placeholder="আপনার নাম লিখুন"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <div className="form-icon">
                                            <i className="far fa-phone"></i>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="phone"
                                                placeholder="আপনার মোবাইল নম্বর লিখুন"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Honeypot field - hidden from the user */}
                                <input
                                    type="hidden"
                                    name="honeypot"
                                    value={formData.honeypot}
                                    onChange={handleChange}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FreeConsultation;
